// add this code
// Flickity.prototype._createResizeClass = function() {
//   this.element.classList.add('flickity-resize');
// };

// Flickity.createMethods.push('_createResizeClass');

// var resize = Flickity.prototype.resize;
// Flickity.prototype.resize = function() {
//   this.element.classList.remove('flickity-resize');
//   resize.call( this );
//   this.element.classList.add('flickity-resize');
// };
Flickity.prototype._touchActionValue = 'pan-y pinch-zoom';
jQuery(function ($) {
    
    $.fn.is_on_screen = function () {

        var win = $(window);
 
        var viewport = {
            top: win.scrollTop() + 48,
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.bottm || viewport.top > bounds.bottom));

    };
    function isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    };
    const carousel = $('.main-carousel-exhibitions');

    carousel.each(function () {
        var $carousel = $(this)
        $carousel.flickity({
            // options
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            // setGallerySize: false,
            percentPosition: true,
            pageDots: false,
            prevNextButtons: false,
            fade: true,
            selectedAttraction: 1,
            friction: 1,
            imagesLoaded: true,
            adaptiveHeight: true
        });
    
        var flkty = $carousel.data('flickity');
        // $carousel.on( 'select.flickity', function() { $(this).flickity('playPlayer') })
        $carousel.on('click', function () {
            $carousel.flickity('next')
            var cell = flkty.selectedIndex + 1
            $carousel.next('.number').find('.cell-number').html(cell)
            // $carousel.flickity('playPlayer')
        })
        $carousel.next('.number').find('.left-arrow').on('click', function () {
            $carousel.flickity('previous')
            var cell = flkty.selectedIndex + 1
            $carousel.next('.number').find('.cell-number').html(cell)
        })
        $carousel.next('.number').find('.right-arrow').on('click', function () {
            $carousel.flickity('next')
            var cell = flkty.selectedIndex + 1
            $carousel.next('.number').find('.cell-number').html(cell)
        })

        
    })

    // setTimeout(function(){

    //     $('img').each(function () {
    //         $(this).attr('src', $(this).data('src'))
    //         // imgCounter = imgCounter + 1
    //         // if()
    //         img.imagesLoaded().done(function(){
    //             img.css({ 'opacity': '1' })
    //             $('.random').packery('layout')
    //         })
    //     })
    // },200)
    function loadImg() {

        var images = $('.lazy').slice(0, 5)
        var imagesCounter = 0
        images.each(function () {
            var img = $(this).attr('id')
            img = $('#' + img)
            img.css({'opacity': '0'})
            img.attr('src', img.data('src'))
            img.removeClass('lazy')
            img.addClass('loaded')
            img.parent('.lazy-parent').removeClass('lazy-parent')
            // console.log(images.length - 1);
            // console.log(imagesCounter);
            // if (images.length > 0 && imagesCounter == images.length - 1) {
                
            //     img.imagesLoaded().done(function(){
            //         img.css({ 'opacity': '1' })
            //         img.parents('.main-carousel').flickity('reloadCells')
            //         loadImg()
            //     })
    
            // } else {
    
                img.imagesLoaded().done(function(){
                    img.css({ 'opacity': '1' })
                    img.parents('.main-carousel-exhibitions').flickity('reloadCells')
                })
        
            //     imagesCounter = imagesCounter + 1
                
            // }
    
        })
        $('.loaded').imagesLoaded().done(function () {
            
        
            loadImg()
          
        })
    }
    loadImg()

    //  *Publi book click
    $('.publi-click').on('click', function () {
        console.log("click");
        var img = $(this).parents('.main-carousel-exhibitions').find('.last')
        img.each(function(){
            $(this).attr('src', $(this).data('src'))
            $(this).removeClass('.last')
            var theimg = $(this)
            $(this).imagesLoaded().done(function(){
                theimg.parents('.main-carousel-exhibitions').flickity('reloadCells')

            })
        })
    })
    $('.publi-click-arr').on('click', function(){
        var img = $(this).parents('.number').prevAll('.main-carousel-exhibitions:first').find('.last')
        img.each(function(){
            $(this).attr('src', $(this).data('src'))
            $(this).removeClass('.last')
            var theimg = $(this)
            $(this).imagesLoaded().done(function(){
                theimg.parents('.main-carousel-exhibitions').flickity('reloadCells')

            })
        })
    }) 
    
    // End Carousel INIT
    // !news
    // *News Click
    $('.news-cta').on('click', function () {
        $('#news').toggleClass('hide')
        $('#info').addClass('hide')
        hideShowMobileMenuIconsOhneTitle()
        $('.nav').toggleClass('black')
        
        if ($(this).hasClass('focus')) {
            
            $('.nav').find('a').each(function () {
                $(this).parents('h3').removeClass('focus')
                if ( $(this).text().toLowerCase()  == window.location.pathname.replaceAll("/","").replace("paloma","")) {
                    $(this).parents('h3').addClass('focus')
                }
            })
        } else {
            $('.nav').find('.focus').each(function () {
                $(this).removeClass('focus')
            })
            $(this).toggleClass('focus')
        }

        if (!$('#news').hasClass('hide')) {
            $('.mobile-title-header').addClass('noopacity')
            $('.year-fix').removeClass('noopacity')
            $('.mobile-title-header').html('NEWS')
            $('.dis').each(function () {
                $(this).css({
                    'position': 'relative',
                    'z-index': 0
                })
            })
        } else {
            $('.mobile-title-header').html('WORKS')
            $('.dis').each(function () {
                $(this).css({
                    'position': '',
                    'z-index': ''
                })
            })
            
        }
    })
    
    $('.close-news').on('click', function () {
        $('#news').toggleClass('hide')
        $('#info').addClass('hide')
        $('.news-cta').toggleClass('focus')
        $('.nav').toggleClass('black')
        $('.nav').find('a').each(function () {
            if ( $(this).text().toLowerCase()  == window.location.pathname.replaceAll("/","").replace("paloma","")) {
                $(this).parents('h3').addClass('focus')
            }
        })
        hideShowMobileMenuIconsOhneTitle()
        if (!$('#news').hasClass('hide')) {
            $('.mobile-title-header').addClass('noopacity')
            $('.year-fix').removeClass('noopacity')
            $('.mobile-title-header').html('NEWS')
            $('.dis').each(function () {
                $(this).css({
                    'position': 'relative',
                    'z-index': 0
                })
            })
        } else {
            $('.mobile-title-header').html('WORKS')
            $('.dis').each(function () {
                $(this).css({
                    'position': '',
                    'z-index': ''
                })
            })
            
        }
        
    })
    // *Info Click
    $('.info-cta').on('click', function () {
        $('#info').toggleClass('hide')
        $('#news').addClass('hide')
        hideShowMobileMenuIconsOhneTitle()
        $('.nav').toggleClass('black')
        
        if ($(this).hasClass('focus')) {
            
            $('.nav').find('a').each(function () {
                $(this).parents('h3').removeClass('focus')
                if ( $(this).text().toLowerCase()  == window.location.pathname.replaceAll("/","").replace("paloma","")) {
                    $(this).parents('h3').addClass('focus')
                }
            })
        } else {
            $('.nav').find('.focus').each(function () {
                $(this).removeClass('focus')
            })
            $(this).toggleClass('focus')
        }

        if (!$('#info').hasClass('hide')) {
            $('.mobile-title-header').addClass('noopacity')
            $('.year-fix').removeClass('noopacity')
            $('.mobile-title-header').html('INFO')
            $('.dis').each(function () {
                $(this).css({
                    'position': 'relative',
                    'z-index': 0
                })
            })
        } else {
            $('.mobile-title-header').html('WORKS')
            $('.dis').each(function () {
                $(this).css({
                    'position': '',
                    'z-index': ''
                })
            })
            
        }
    })
    
    $('.close-info').on('click', function () {
        $('#info').toggleClass('hide')
        $('#news').addClass('hide')
        $('.info-cta').toggleClass('focus')
        $('.nav').toggleClass('black')
        $('.nav').find('a').each(function () {
            if ( $(this).text().toLowerCase()  == window.location.pathname.replaceAll("/","").replace("paloma","")) {
                $(this).parents('h3').addClass('focus')
            }
        })
        hideShowMobileMenuIconsOhneTitle()
        if (!$('#info').hasClass('hide')) {
            $('.mobile-title-header').addClass('noopacity')
            $('.year-fix').removeClass('noopacity')
            $('.mobile-title-header').html('INFO')
            $('.dis').each(function () {
                $(this).css({
                    'position': 'relative',
                    'z-index': 0
                })
            })
        } else {
            $('.mobile-title-header').html('WORKS')
            $('.dis').each(function () {
                $(this).css({
                    'position': '',
                    'z-index': ''
                })
            })
            
        }
        
    })


    // * Hide Show Menu and icons mobile
    function hideShowMobileMenuIcons() {
        $('.mobile-options').toggleClass('hide')
        $('#mobile-svg').toggleClass('hide')
        $('#mobile-svg-kreuz').toggleClass('hide')
        $('.mobile-title-header').toggleClass('noopacity')
        $('.year-fix').toggleClass('menu-open')

        $('.dis').each(function () {
            if(!$(this).hasClass('hideAll'))
                $(this).toggleClass('hide2')
        })
        $('.sticky-year').toggleClass('invisible')
    }
    function hideShowMobileMenuIconsOhneTitle() {
        $('.mobile-options').toggleClass('hide')
        $('#mobile-svg').toggleClass('hide')
        $('#mobile-svg-kreuz').toggleClass('hide')
        
        $('.dis').each(function () {
            if(!$(this).hasClass('hideAll'))
            $(this).toggleClass('hide2')
        })
        $('.sticky-year').toggleClass('invisible')
    }

    // * Year Clickt^
    
    $('.dis').find('span').on('click', function () {
        if ($(this).parents('.dis').next('.single-year').hasClass('hideAll')) {

            // $('.single-year').each(function () {
            //     $(this).addClass('hideAll')
            // })
            $(this).parents('.dis').next('.single-year').removeClass('hideAll')
            $(this).parents('.dis').removeClass('hideAll')
            $(this).parents('.dis').removeClass('hideAllNeu')
            $(this).parents('.dis').prevAll('.plus:first').css({'display':'none'})
            $(this).parents('.dis').find('.title-ex-mobile').css({ 'display': 'none' })
            var img = $(this).parents('.dis').next('.single-year').find('img')
            img.each(function () {
                const theimg = $(this)
                $(this).removeClass('.lazy')
                $(this).attr('src', $(this).data('src'))
                $(this).imagesLoaded().done(function () {
                    // $(this).parents('.main-carousel').flickity('reloadCells')
                //    theimg.parents('.main-carousel-exhibitions').flickity('reposition')
                    theimg.parents('.main-carousel-exhibitions').flickity('reloadCells')
                })
            })

            // $(this).parents('.dis').css({'display':'none'})
            // $(this).parents('.dis').find('span:last-of-type').css({ 'display': 'none' })
            
            // CLose
            $(this).parents('.dis').nextAll('.plusClose:first').css({'display':'inline-block'})
            // $(this).parents('.dis:first').find('.close').toggle()
            $(this).parents('.dis').prev('.sticky-year').addClass('invisible')

            // // If year Was openened
            // var id = $(this).parents('.dis').attr('id')
            // var array_of_years_dis = []
            // $('.dis').each(function () {
            //     var id_to_check = $(this).attr('id')
            //     if (id == id_to_check && !$(this).hasClass('hideAllNeu')) {
            //         array_of_years_dis.push($(this))
            //     }
            // })

            
          
            // if (array_of_years_dis.length > 1) {

            //     // First Single-year
            //     var first_dis = array_of_years_dis.shift()
            //     var first_single_year = $(first_dis).next('.single-year')
                
            //     $.each(array_of_years_dis, function (i, val) {
            //         var html = $(val).next('.single-year').html()
            //         first_single_year.append(html)
            //         $(val).prev('.plus').remove()
            //         $(val).next('.single-year').remove()
            //         $(val).remove()
                   
            //     });
            // }
            

            // $('html, body').scrollTop(0)
            // $('html, body').scrollTop($(this).parents('.dis').offset().top) 
            

            carousel.each(function(){
                $(this).flickity('resize')
            
            })
        } 
    })

    $('.close').on('click', function () {
        $(this).parents('.dis').next('.single-year').addClass('hideAll')
        $(this).parents('.dis').addClass('hideAll')
        $(this).parents('.dis').addClass('hideAllNeu')
        $(this).parents('.dis').prevAll('.plus:first').css({'display':'block'})
        $(this).parents('.dis').find('.title-ex-mobile').toggle()
        // $(this).parents('.dis').find('span:last-of-type').css({ 'display': 'none' })
        
        // CLose
        $(this).parents('.dis:first').find('.close').toggle()

        $(this).parents('.dis').prev('.sticky-year').removeClass('invisible')
        $(this).parents('.dis').prev('.sticky-year').removeClass('open')
    })
    $('.plusClose').on('click', function () {
        $(this).prev('.single-year').addClass('hideAll')
        $(this).prevAll('.dis:first').addClass('hideAll hideAllNeu')
        $(this).prevAll('.dis:first').find('.title-ex-mobile').toggle()
        $(this).prevAll('.plus:first').css({ 'display': 'block' })
        
        $(this).css({ 'display': 'none' })

        $(this).prevAll('.sticky-year:first').removeClass('invisible')
        $(this).prevAll('.sticky-year:first').removeClass('open')
    })

    $('.plus').on('click', function () {
        if ($(this).nextAll('.dis:first').next('.single-year').hasClass('hideAll')) {

            $(this).nextAll('.dis:first').next('.single-year').removeClass('hideAll')
            $(this).nextAll('.dis:first').removeClass('hideAll')
            $(this).nextAll('.dis:first').removeClass('hideAllNeu')
            // $('html, body').scrollTop(0)
            // $('html, body').scrollTop($(this).parents('.dis').offset().top) 
            // $(this).toggle()
            var img = $(this).nextAll('.dis:first').next('.single-year').find('img')
            img.each(function () {
                const theimg = $(this)
                $(this).removeClass('.lazy')
                $(this).attr('src', $(this).data('src'))
                $(this).imagesLoaded().done(function () {
                    theimg.parents('.main-carousel-exhibitions').flickity('reloadCells')
                })
            })
            $(this).toggle()
            // $(this).nextAll('.dis:first').find('.close').toggle()
            // Close
            $(this).nextAll('.plusClose:first').css({'display':'inline-block'})
            $(this).nextAll('.dis:first').find('.title-ex-mobile').css({'display':'none'})

            $(this).next('.sticky-year').addClass('hide')
            $(this).next('.sticky-year').addClass('invisible')
            // If year WAllas openened
            // var id = $(this).nextAll('.dis:first').attr('id')
            // var array_of_years_dis = []
            // $('.dis').each(function () {
            //     var id_to_check = $(this).attr('id')
            //     if (id == id_to_check && !$(this).hasClass('hideAllNeu')) {
            //         array_of_years_dis.push($(this))
            //     }
            // })

            
          
            // if (array_of_years_dis.length > 1) {

            //     // First Single-year
            //     var first_dis = array_of_years_dis.shift()
            //     var first_single_year = $(first_dis).next('.single-year')
                
            //     $.each(array_of_years_dis, function (i, val) {
            //         var html = $(val).next('.single-year').html()
            //         first_single_year.append(html)
            //         $(val).prev('.plus').remove()
            //         $(val).next('.single-year').remove()
            //         $(val).remove()
                   
            //     });
            // }
            carousel.each(function(){
                $(this).flickity('resize')
                
            })
        } 
    })
    // * Logo Footer Konture
    $('.footer-logo').hover(function () {
        if ($(window).width() > 900) {

            $('#Ebene_1').toggleClass('hide')
            $('#Ebene_1_konture').toggleClass('hide')
        }
    })

    //* Logo Click
    $('.footer-logo').on('click', function () {

        
        window.location.href = home.url
        
    })

    // * Mobile Icon Click
    $('.mobile-svg').on('click', function () {
        hideShowMobileMenuIcons()
    })

    // * Back to Top
    $('.back').on('click', function () {
        $('html,body').scrollTop(0)
    })

    //* Mobile Title disappear with scroll
    var height = $(window).height()
    $(window).on('scroll', function () {
        // console.log($(window).scrollTop())
        var scrolled = $(window).scrollTop()
        
        var pathname = window.location.pathname.indexOf('publications');
        // console.log(pathname);
        if (pathname < 0) {
            
            if (scrolled > 10) {
                $('.mobile-title-header').css({'opacity': '0'})
                $('.year-fix').removeClass('noopacity')
            } else {
                $('.mobile-title-header').css({'opacity': '1'})
                $('.year-fix').addClass('noopacity')
                
            }
        }

        if (scrolled > height) {
            $('#nav-bottom').removeClass('hide')
        } else {
            $('#nav-bottom').addClass('hide')
            
        }
        isTargetVisble()
        newApproach()
    })

    //* PFEILE
    $('.pfeile-links-works').on('click', function() {
        var prev = $(this).parents('.dis').prevAll('.dis').slice(0, 1)
        
        $('html, body').animate({
            scrollTop: prev.next('.single-year').offset().top
        },500)
    } )
    $('.pfeile-rechts-works').on('click', function() {
        var next = $(this).parents('.dis').nextAll('.dis').slice(0, 1)
        // console.log(next)
        $('html, body').animate({
            scrollTop: next.next('.single-year').offset().top
        },500)
    } )

    

    function newApproach() {
        $('.dis').each(function () {
            if ($(this).next('.single-year').height() > 0) {
                var current = $(this).next('.single-year')
                var viewportOffset = current.get(0).getBoundingClientRect();
                var top = viewportOffset.top;
              
                if (70 >= top && top > -current.height()) {
                    // current.prevAll('.sticky-year:first').addClass('open')
                    $('.year-fix').html(current.prevAll('.sticky-year:first').html())
                } else {
                    // current.prevAll('.sticky-year:first').removeClass('open')
                    
                }
            } else {
                var current = $(this)
                var viewportOffset = current.get(0).getBoundingClientRect();
                var top = viewportOffset.top;
                
                if (70 >= top  && top > 0) {
                    // current.prev('.sticky-year').addClass('open')

                    $('.year-fix').html(current.prev('.sticky-year').html())
                } else {
                    // current.prev('.sticky-year').removeClass('open')
                    
                }
                
            }
        });
    }
    // Visible
    function isTargetVisble() {
        var retunVal = false;
        $('.dis').each(function () {
            if ($(this).next('.single-year').is_on_screen()) {
                $(this).removeClass('hide')
            } else {
                $(this).addClass('hide')
                
            }
        });
        return retunVal;
    }

    function resizeMainSingular() {
        var windowHeight = $(window).height()
        var windowWidth = $(window).width()
        var headerHeight = $('.nav-mobile-singular').outerHeight()
        var numberHeight = $('.number').outerHeight()

        var op = windowHeight - headerHeight


        // console.log(headerHeight)
        if (isMobileDevice()) {
            
            if (windowWidth >= 900) {
                
                $('.ex-singular').css({ 'height': windowHeight })
            } else {
                
                $('.ex-singular').css({ 'height': op })
            }
        } else {
            
            $('.ex-singular').css({'height': ''})
        } 

    }
    // resizeMainSingular()

    /**
     * *Change color Underline
     */

    $('.ex-title').each(function () {
        var a = $(this).find('a')
        a.each(function () {
            var color = $(this).css('color');
            // console.log(color)
            $(this).get(0).style.setProperty('--linkColor', color);
        })
        
        
    })

    /**
     * Fix Publi Book Problems
     */

    function fixWidth() {
        var disW = $('#exhibitions-main').find('.dis').first().find('span:nth-child(2)').width()
        var actualSingularW = $('#exhibitions-main').width()
        // console.log(actualSingularW)
        
        var difW = actualSingularW - disW - 16
        // console.log(difW)

        if ($(window).width() >= 900) {
            $('.ex-singular').css({ 'width': difW })
            
        } else {
            
            $('.ex-singular').css({ 'width': '100%' })
        }
    }
    fixWidth()
    
    
    
    $(window).on('resize', function () {
        fixWidth()
        
        if ($(window).width() >= 900) {
            // *Restore handy
            $('.mobile-title-header').removeClass('noopacity')
            $('.year-fix').addClass('noopacity')
            $('.mobile-options').addClass('hide')
            $('#mobile-svg').removeClass('hide')
            $('#mobile-svg-kreuz').addClass('hide')

            $('.dis').each(function () {
                $(this).removeClass('hide2')
            })
        }
    })
})